module.exports = __webpack_public_path__ + "img/39000.17b2b6bc.jpg";